module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/passion_3x.cbd8d2d.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/passion_3x.png
// module id = 4Y9k
// module chunks = 41